import { render, staticRenderFns } from "./zhujing.vue?vue&type=template&id=88000c80&scoped=true"
import script from "./zhujing.vue?vue&type=script&lang=js"
export * from "./zhujing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88000c80",
  null
  
)

export default component.exports